import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, Music } from 'lucide-react';
import { Button } from './ui/button';
import { contactData } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'About', href: '#about' },
    { name: 'Services', href: '#services' },
    { name: 'Pricing', href: '#pricing' },
    { name: 'Coverage', href: '#coverage' },
    { name: 'Watch', href: '#watch' },
    { name: 'Book', href: '#booking' },
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-stone-950/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-gold-500 flex items-center justify-center">
              <Music className="w-5 h-5 text-white" />
            </div>
            <div className="hidden sm:block">
              <p className="text-white font-bold text-lg tracking-wide">CountrySoulN'Roll</p>
              <p className="text-gold-400 text-xs tracking-widest uppercase">Entertainment</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.name}
                onClick={() => scrollToSection(link.href)}
                className="text-stone-300 hover:text-gold-400 transition-colors duration-200 text-sm font-medium tracking-wide"
              >
                {link.name}
              </button>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center gap-4">
            <a
              href={`tel:${contactData.receptionist.phone}`}
              className="flex items-center gap-2 text-stone-300 hover:text-gold-400 transition-colors"
            >
              <Phone className="w-4 h-4" />
              <span className="text-sm">{contactData.receptionist.phone}</span>
            </a>
            <Button
              onClick={() => scrollToSection('#contact')}
              className="bg-gold-500 hover:bg-gold-600 text-white px-6 py-2 rounded-md font-medium transition-all duration-200 hover:shadow-lg hover:shadow-gold-500/25"
            >
              Book Now
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden absolute top-full left-0 right-0 bg-stone-950/98 backdrop-blur-md transition-all duration-300 overflow-hidden ${
          isMobileMenuOpen ? 'max-h-96 border-b border-stone-800' : 'max-h-0'
        }`}
      >
        <nav className="flex flex-col px-4 py-4 gap-2">
          {navLinks.map((link) => (
            <button
              key={link.name}
              onClick={() => scrollToSection(link.href)}
              className="text-stone-300 hover:text-gold-400 py-3 text-left font-medium border-b border-stone-800/50 last:border-0"
            >
              {link.name}
            </button>
          ))}
          <Button
            onClick={() => scrollToSection('#contact')}
            className="bg-gold-500 hover:bg-gold-600 text-white mt-4 py-3"
          >
            Book Now
          </Button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
